import { render, staticRenderFns } from "./templete-list.vue?vue&type=template&id=174cfef3&scoped=true&"
import script from "./templete-list.vue?vue&type=script&lang=js&"
export * from "./templete-list.vue?vue&type=script&lang=js&"
import style0 from "./templete-list.vue?vue&type=style&index=0&id=174cfef3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174cfef3",
  null
  
)

export default component.exports